import { type MCPServerInfo } from '../../types';

const GoogleSheetsServer: MCPServerInfo = {
  serverId: 'GOOGLE_SHEETS',
  name: 'Google Sheets',
  slug: 'google-sheets',
  description:
    'Google Sheets MCP Server for reading, writing, and managing spreadsheets',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/google-mcp-servers',
    commitSha: 'f86a7e2e',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleSheetsServer;
